// 去旧IM：联系人/群列表改走自研后端（getJoinedGroupsGo/getGroupDetailGo），不再依赖旧IM SDK
import { getJoinedGroupsGo, getGroupDetailGo } from '@/api/custom'
// import { useLocalStorage } from '@vueuse/core';
import { sortPinyinFriendItem, handlePresence } from '@/utils/handleSomeData'
import _ from 'lodash'
const Contacts = {
    state: {
    // friendList: useLocalStorage('friendList', {}),
        friendList: {},
        // groupList: useLocalStorage('groupList', {}),
        groupList: {},
        // sortedFriendList: useLocalStorage('sortedFriendList', {}),
        sortedFriendList: {},
        friendBlackList: [],
    },
    mutations: {
        SET_FRIEND_LIST: (state, payload) => {
            state.friendList = _.assign({}, payload)
        },
        SET_BLACK_LIST: (state, payload) => {
            state.friendBlackList = _.assign([], payload)
        },
        SET_FRIEND_PRESENCE: (state, status) => {
            const friendList = state.friendList
            status.length > 0 &&
        status.forEach((item) => {
            const commonStatus = handlePresence(item)
            if (friendList[commonStatus.uid]) {
                friendList[commonStatus.uid].userStatus = commonStatus
            }
        })
        },
        SET_SORDED_FRIEND_LIST: (state, payload) => {
            state.sortedFriendList = _.assign({}, payload)
        },
        SET_GROUP_LIST: (state, payload) => {
            //init 为初始化获取 replenish 补充群列表（包括补充群详情）
            const { setType, data } = payload
            if (setType === 'init') {
                state.groupList = _.assign({}, data)
            }
            if (setType === 'replenish') {
                const id = data.id || data.groupId || data.groupid
                const name = data.name || data.groupName || data.groupname
                const { disabled } = data
                if (state.groupList[id]) {
                    state.groupList[id] = {
                        ...state.groupList[id],
                        groupname: state.groupList[id].groupname || name,
                        groupName: state.groupList[id].groupName || name,
                        groupDetail: data
                    }
                } else {
                    state.groupList[id] = {
                        groupid: id,
                        groupname: name,
                        groupName: name,
                        disabled: disabled,
                        groupDetail: data,
                    }
                }
                console.log('>>>>>补充群详情', data)
            }
        },
        //示例优化方向--减少群组详情的调用，转为更新本地群组详情数据
        UPDATE_GROUP_INFOS: (state, payload) => {
            console.log('>>>>>>开始修改', payload)
            const { groupId, type, params } = payload
            //key(群id)，type（群详情对应要修改的字段）
            if (state.groupList[groupId] && state.groupList[groupId].groupDetail) {
                switch (type) {
                //修改群名
                case 'groupName':
                    {
                        console.log('>>>>>>进入群组名称修改')
                        state.groupList[groupId].groupDetail.name = params
                    }
                    break
                case 'groupDescription':
                    {
                        state.groupList[groupId].groupDetail.description = params
                    }
                    break
                case 'addAffiliationsCount':
                    {
                        state.groupList[groupId].groupDetail.affiliations_count =
                state.groupList[groupId].groupDetail.affiliations_count + 1
                    }
                    break
                case 'delAffiliationsCount':
                    {
                        state.groupList[groupId].groupDetail.affiliations_count =
                state.groupList[groupId].groupDetail.affiliations_count - 1
                    }
                    break
                default:
                    break
                }
            }
        },
        //示例优化方向--更改本地群组列表群名(或其他状态)
        UPDATE_GROUP_LIST: (state, payload) => {
            const { type, groupId, groupName } = payload
            if (type === 'updateGroupName') {
                console.log('>>>>>更新本地群组列表群名')
                if (!state.groupList[groupId]) {
                    state.groupList[groupId] = { groupid: groupId }
                }
                state.groupList[groupId].groupname = groupName
                state.groupList[groupId].groupName = groupName
                state.groupList[groupId].name = groupName
                if (state.groupList[groupId].groupDetail) {
                    state.groupList[groupId].groupDetail.name = groupName
                    state.groupList[groupId].groupDetail.groupName = groupName
                    state.groupList[groupId].groupDetail.groupname = groupName
                }
            }
            if (type === 'deleteFromList') {
                console.log('>>>>>从本地群组列表中删除某个群')
                state.groupList[groupId] && delete state.groupList[groupId]
            }
        },
    },
    actions: {
        // 好友列表：客服 IM 无好友体系，去旧IM后置空（联系人主要靠会话列表）
        fetchFriendList: async ({ commit }) => {
            commit('SET_FRIEND_LIST', {})
            commit('SET_SORDED_FRIEND_LIST', {})
        },
        // 黑名单：业务无，置空
        fetchBlackList: async ({ commit }) => {
            commit('SET_BLACK_LIST', [])
        },
        // 他人用户属性：去旧IM后不再批量拉旧IM资料，消息已带 formNick/formAvatar，返回空对象
        getOtherUserInfo: async () => {
            return {}
        },
        // 在线状态订阅：去旧IM后无 presence 能力，noop
        subFriendsPresence: async () => {},
        unsubFriendsPresence: async () => {},
        // 我加入的群 → 自研 Go 后端（字段 groupId/groupName，转成本地 groupList 结构）
        fetchGroupList: async ({ commit }, params) => {
            try {
                const res = await getJoinedGroupsGo(params)
                const list = (res && res.data) || []
                const goupListData = {}
                list.forEach((g) => {
                    const gid = g.groupId || g.groupid
                    if (gid) {
                        goupListData[gid] = {
                            groupid: gid,
                            groupname: g.groupName,
                            groupDesc: g.groupDesc,
                            ...g
                        }
                    }
                })
                commit('SET_GROUP_LIST', { setType: 'init', data: goupListData })
            } catch (e) {
                console.error('[去旧IM] 拉群列表失败', e)
            }
        },
        // 指定群详情 → 自研 Go 后端 getGroup
        getAssignGroupDetail: async ({ commit }, goupsId) => {
            try {
                const res = await getGroupDetailGo(goupsId)
                const g = res && res.data
                if (g) {
                    const gid = g.groupId || goupsId
                    commit('SET_GROUP_LIST', {
                        setType: 'replenish',
                        data: {
                            groupid: gid,
                            groupname: g.groupName,
                            groupDesc: g.groupDesc,
                            groupDetail: g,
                            ...g
                        }
                    })
                }
            } catch (e) {
                console.error('[去旧IM] 拉群详情失败', e)
            }
        },
    },
}

export default Contacts
